export const truncateText = (text, charCountLimit = 25) => {
  if (text?.length > charCountLimit) {
    return `${text.substring(0, charCountLimit)}...`;
  }

  return text;
};
